import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useLazyQuery } from '@apollo/client';
import { PopoverMenu } from '@guildeducationinc/recess';
import DeleteOutlineIcon from '@guildeducationinc/recess/icons/DeleteOutlineIcon';
import FileDownloadOutlinedIcon from '@guildeducationinc/recess/icons/FileDownloadOutlinedIcon';
import MoreVertIcon from '@guildeducationinc/recess/icons/MoreVertIcon';
import { GET_URL, TrackableButton, trackClickEvent, useAlert, useLocale } from 'pe-core-frontend';
import { useState } from 'react';
import styles from './Documents.module.scss';
export const Documents = ({ documents, editable, onChange, editableForNew, intialDocuments, }) => {
    const { t } = useLocale();
    const { showAlert } = useAlert();
    const [getUrl] = useLazyQuery(GET_URL);
    const [fetching, setFetching] = useState(false);
    const handleDocClick = (doc) => async (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (fetching)
            return;
        try {
            setFetching(true);
            const { data } = await getUrl({ variables: { input: { s3Key: doc.s3Key } } });
            window.open(data.getUrl, '_blank');
        }
        catch {
            showAlert(t('Error fetching document'));
        }
        finally {
            setFetching(false);
        }
    };
    const handleRemove = (doc) => {
        if (editable && documents.length > 0) {
            onChange && onChange(documents.filter(d => d.s3Key !== doc.s3Key));
        }
    };
    const isNewDocument = (doc) => {
        if (!intialDocuments)
            return false;
        return !intialDocuments.find(d => d.s3Key === doc.s3Key);
    };
    return (_jsx("div", { className: styles.documents, children: _jsx("div", { className: styles.list, children: documents.map(doc => (_jsx("div", { className: styles.cardRow, children: _jsxs("div", { className: styles.row, children: [_jsx("div", { className: styles.title, children: _jsxs(TrackableButton, { btnType: 'link', enText: 'Download', tag: `document_${doc.name}`, className: 'flex flexItems--center underline', to: '#', onClick: handleDocClick(doc), children: [doc.name, " ", _jsx(FileDownloadOutlinedIcon, { className: 'ml-1', size: 16 })] }) }), (editable || (editableForNew && isNewDocument(doc))) && (_jsxs("div", { className: styles.actions, children: [_jsx("div", { className: styles.desktopActions, children: _jsx(TrackableButton, { btnType: 'icon', enText: 'Remove', tag: `document_${doc.name}`, appearance: 'ghost', label: t('Remove'), icon: _jsx(DeleteOutlineIcon, { size: 24 }), onClick: () => handleRemove(doc) }) }), _jsx("div", { className: styles.mobileActions, children: _jsx(PopoverMenu, { id: doc.s3Key, data: doc, actions: [
                                            {
                                                name: t('Remove'),
                                                type: 'action',
                                                onClick: doc => {
                                                    handleRemove(doc);
                                                    trackClickEvent('Remove', `document_${doc.name}`, 'button', t('Remove'));
                                                },
                                            },
                                        ], children: _jsx(TrackableButton, { btnType: 'icon', enText: 'Actions', tag: `document_${doc.name}`, appearance: 'ghost', label: t('Actions'), icon: _jsx(MoreVertIcon, { size: 24 }) }) }) })] }))] }) }, doc.s3Key))) }) }));
};
